function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import t from 'prop-types';
import { Box } from '@dna/box';
import { css, iconStyles } from '@dna/core';
const LEVEL = {
  xsmall: 'xsmall',
  small: 'small',
  medium: 'medium',
  large: 'large',
  xlarge: 'xlarge'
};
/** @type {import('@dna/react-utils/pkg/dist-web/types').ForwardRefExoticComponent<HTMLOrSVGElement, typeof IconPropTypes>} */

export const Icon = /*#__PURE__*/React.forwardRef(function (props, ref) {
  let {
    className,
    as,
    level,
    children,
    ...otherProps
  } = props;
  let styles = iconStyles({
    level
  });
  return /*#__PURE__*/React.createElement(Box, _extends({
    "aria-hidden": true,
    ref: ref,
    role: "img",
    viewBox: "0 0 24 24"
  }, otherProps, {
    as: "svg",
    className: css(styles)
  }), children);
});
let IconPropTypes = {
  /**
   * Level in the typographic heirarchy.
   * @type {import('prop-types').Requireable<keyof typeof LEVEL>}
   */
  level: t.oneOf(Object.keys(LEVEL))
};
Icon.propTypes = IconPropTypes;
Icon.defaultProps = {
  level: 'medium'
};